import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { OrganizationSearchCriteria } from '../models/searchCriteria/OrganizationSearchCriteria';
import { Organization } from '../models/Organization';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: OrganizationSearchCriteria): Observable<PagedData<Organization>> {
    return this.httpClient.post<PagedData<Organization>>(environment.apiUrl + "organizations/filtered",searchCriteria);
  }

  get(id: number): Observable<Organization> {
    return this.httpClient.get<Organization>(environment.apiUrl + "organizations/" + id);
  }

  save(organization: Organization): Observable<void> {
    if (organization.id == 0 || organization.id === undefined) {
      return this.httpClient.post<void>(environment.apiUrl + "organizations", organization);
    }
    else {
      return this.httpClient.put<void>(environment.apiUrl + "organizations/" + organization.id, organization);
    }
  }
 
  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "organizations/" + id);
  }
}  